import clsx from 'clsx'
import styles from './SelectSubheader.module.scss'
import { ReactNode } from 'react'
import { useSelectContext } from './SelectContext'

export const SelectSubheader = ({ children }: { children: ReactNode }) => {
  const { size } = useSelectContext()
  return <li className={clsx('mui-select-subheader', styles.wrapper, styles[size])}>{children}</li>
}
